import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

import { Side } from '../../../enums/side'
import { BillType } from '../../bills/enums/billType'
import { PayableSubjectType } from '../types/payableSubjectType'

type InitialSubjectTypeType = BillType | InvoiceType | undefined | null
type PayableSubjectTypeType = PayableSubjectType

export const getCashSide = (
  payableSubjectType: PayableSubjectTypeType,
  initialSubjectType?: InitialSubjectTypeType,
): Side => {
  const isInvoice = payableSubjectType === InvoiceType.Invoice || payableSubjectType === InvoiceType.ExternalInvoice
  if (isInvoice) {
    if (initialSubjectType === InvoiceType.CreditNote) {
      return Side.Credit
    } else {
      return Side.Debit
    }
  } else {
    if (initialSubjectType === BillType.CreditNote) {
      return Side.Debit
    } else {
      return Side.Credit
    }
  }
}
